const GOOGLE_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL;

const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

export const postFormData = async (formData, { retries = 3, delayMs = 2000 } = {}) => {
    for (let attempt = 0; attempt <= retries; attempt++) {
        try {
            return await fetch(GOOGLE_SCRIPT_URL, {
                method: "POST",
                mode: "no-cors",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });
        } catch (err) {
            if (attempt === retries) throw err;
            console.warn(`Submit failed (attempt ${attempt + 1}), retrying in ${delayMs}ms…`, err);
            await sleep(delayMs);
        }
    }
};